module.exports = __webpack_public_path__ + "img/no_data_video.9dbca0cc.png";